(function () {
  function initCollectionRowsFilters(section) {
    var toggle = section.querySelector('[data-collection-rows-filter-toggle]');
    var panel = section.querySelector('[data-collection-rows-filter-panel]');

    if (!toggle || !panel) return;

    var chips = section.querySelectorAll('[data-collection-rows-filter-group]');
    var cards = section.querySelectorAll('[data-collection-rows-shape]');
    var countValue = section.querySelector('[data-collection-rows-filter-count-value]');
    var countLabel = section.querySelector('[data-collection-rows-filter-count-label]');

    var active = { shape: new Set(), size: new Set() };

    toggle.addEventListener('click', function () {
      var expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!expanded));
      panel.classList.toggle('is-open', !expanded);
      panel.setAttribute('aria-hidden', String(expanded));
    });

    function cardMatchesGroup(card, group) {
      if (active[group].size === 0) return true;

      if (group === 'shape') {
        var cardShape = card.getAttribute('data-collection-rows-shape') || '';
        return active.shape.has(cardShape);
      }

      var cardSizes = (card.getAttribute('data-collection-rows-size') || '')
        .split(' ')
        .filter(Boolean);
      return cardSizes.some(function (size) {
        return active.size.has(size);
      });
    }

    function cardMatchesAllGroups(card) {
      return Object.keys(active).every(function (group) {
        return cardMatchesGroup(card, group);
      });
    }

    function cardHasValue(card, group, value) {
      if (group === 'shape') {
        return (card.getAttribute('data-collection-rows-shape') || '') === value;
      }
      var cardSizes = (card.getAttribute('data-collection-rows-size') || '')
        .split(' ')
        .filter(Boolean);
      return cardSizes.indexOf(value) !== -1;
    }

    function applyFilters() {
      var visibleCount = 0;

      cards.forEach(function (card) {
        var matches = cardMatchesAllGroups(card);
        card.classList.toggle('collection-rows__grid-item--hidden', !matches);
        if (matches) visibleCount += 1;
      });

      if (countValue) countValue.textContent = visibleCount;
      if (countLabel) {
        countLabel.textContent = visibleCount === 1 ? countLabel.dataset.labelOne : countLabel.dataset.labelOther;
      }

      recomputeMosaicState();
    }

    function recomputeMosaicState() {
      var mosaicRows = section.querySelectorAll('[data-layout-mode="mosaique"]');
      mosaicRows.forEach(function (row) {
        var serviettesSection = row.querySelector('[data-mosaic-role="serviettes"]');
        if (serviettesSection) {
          var visibleServiettes = serviettesSection.querySelectorAll(
            '.collection-rows__grid-item:not(.collection-rows__grid-item--hidden)'
          ).length;
          serviettesSection.style.display = visibleServiettes > 0 ? '' : 'none';
        }

        var mixedSection = row.querySelector('[data-mosaic-role="mixed"]');
        if (!mixedSection) return;

        var visibleDdv = mixedSection.querySelectorAll(
          '.collection-rows__mosaic-item--ddv:not(.collection-rows__grid-item--hidden)'
        ).length;
        var visibleCdt = mixedSection.querySelectorAll(
          '.collection-rows__mosaic-item--cdt:not(.collection-rows__grid-item--hidden)'
        ).length;

        var newState;
        if (visibleDdv > 0 && visibleCdt > 0) newState = 'both';
        else if (visibleDdv > 0) newState = 'ddv-only';
        else if (visibleCdt > 0) newState = 'cdt-only';
        else newState = 'none';

        mixedSection.style.display = newState === 'none' ? 'none' : '';

        if (mixedSection.getAttribute('data-mosaic-state') !== newState) {
          var grid = mixedSection.querySelector('.collection-rows__grid');
          if (grid && newState !== 'none') {
            grid.style.transition = 'opacity 0.15s ease';
            grid.style.opacity = '0';
            setTimeout(function () {
              mixedSection.setAttribute('data-mosaic-state', newState);
              grid.style.opacity = '';
              setTimeout(function () { grid.style.transition = ''; }, 160);
            }, 150);
          } else {
            mixedSection.setAttribute('data-mosaic-state', newState);
          }
        }
      });
    }

    function updateChipAvailability() {
      chips.forEach(function (chip) {
        var group = chip.getAttribute('data-collection-rows-filter-group');
        var value = chip.getAttribute('data-collection-rows-filter-value');

        var available = Array.prototype.some.call(cards, function (card) {
          if (!cardHasValue(card, group, value)) return false;

          return Object.keys(active).every(function (otherGroup) {
            if (otherGroup === group) return true;
            return cardMatchesGroup(card, otherGroup);
          });
        });

        chip.classList.toggle('collection-rows__filter-chip--disabled', !available);
      });
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        if (chip.classList.contains('collection-rows__filter-chip--disabled')) return;

        var group = chip.getAttribute('data-collection-rows-filter-group');
        var value = chip.getAttribute('data-collection-rows-filter-value');
        var pressed = chip.getAttribute('aria-pressed') === 'true';

        chip.setAttribute('aria-pressed', String(!pressed));

        if (pressed) {
          active[group].delete(value);
        } else {
          active[group].add(value);
        }

        applyFilters();
        updateChipAvailability();
      });
    });

    updateChipAvailability();
    recomputeMosaicState();
  }

  document
    .querySelectorAll('[data-collection-rows-filters]')
    .forEach(initCollectionRowsFilters);
})();
